import * as moment from 'moment';
import * as React from 'react';
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
import { bindActionCreators, Dispatch } from "redux";
import { signOut as signOutAction } from "../../actions/loginActions";
import { clearMailData as clearMailDataAction, refreshList as refreshListAction, savePaginationInfo as savePaginationInfoAction, selectMessage as selectMessageAction } from "../../actions/mailActions";
import { addNotification as addNotificationAction, clearNotifications as clearNotificationsAction } from "../../actions/notificationsActions";
import { MailService } from "../../services/mail";
import MessageNotification from '../common/MessageNotification';
import Notification from '../common/Notification';
import Header from '../layout/Header';
import MessageList from "./MessageList";
import MessageListMobile from "./MessageListMobile";
import MessagePreview from "./MessagePreview";
import Message from "./model/Message";
import Paging from "./model/Paging";
import NavBar from "./NavBar";
import Paginator from "./Paginator";
import SelectedMessagesPreview from "./SelectedMessagesPreview";

interface IQuarantineManagerProps extends RouteComponentProps<any> {
  csrf: string;
  loginTime: number;
  messageList: Message[];
  refreshList: (messages: Message[]) => any;
  savePaginationInfo: (paginationInfo: Paging) => any;
  selectMessage: (messages: Message) => any;
  addNotification: (notification: Notification) => any;
  clearMailData: () => any;
  clearNotifications: () => any;
  signOut: () => any;
  user: string;
  wsid: string;
  sortField: string;
  isDesc: boolean;
}

interface IQuarantineManagerState {
  loaded: boolean;
  windowWidth: number;
}

class QuarantineManager extends React.Component<IQuarantineManagerProps, IQuarantineManagerState> {
  public mailService: MailService;

  constructor(props: IQuarantineManagerProps) {
    super(props);
    this.state = {
      loaded: false,
      windowWidth: window.innerWidth
    };
    this.mailService = new MailService(this.props.user, this.props.wsid, this.props.csrf);
    this.updateWindowSize = this.updateWindowSize.bind(this);
  }

  public render() {
    const selectedMessages = this.props.messageList.filter((m) => m.selected).length;
    return (
      <div>
        <div className="spacer">
          <MessageNotification />
        </div>
        <Header user={this.props.user} />
        {this.state.windowWidth <= 1023 && <div className="sidebar">
          <div className="sidebar">
            <div className="top-container">
              <NavBar windowWidth={this.state.windowWidth} />
            </div>
            <MessageListMobile />
          </div>
        </div>}
        {this.state.windowWidth > 1023 &&
          <div>
            <div className="desktop-table">
              <div className="top-container">
                <NavBar windowWidth={this.state.windowWidth} />
              </div>
              <MessageList />
            </div>
            <Paginator currentPage={1} />
            {this.state.loaded && selectedMessages === 0 && this.props.messageList.length > 0 && <MessagePreview />}
            {this.state.loaded && selectedMessages > 0 && <SelectedMessagesPreview />}
          </div>}
      </div>
    );
  }

  public async getMessageList(page: number, pageSize: number) {
    try {
      const response = await this.mailService.list(page, pageSize, this.props.isDesc ? 'desc' : 'asc', this.props.sortField);

      if (!response.ok) {
        throw new Error(response.status.toString());
      }

      const msgList = await response.json();
      this.props.refreshList(msgList.messages);
      this.props.selectMessage(msgList.messages[0]); // select first message by default
      this.props.savePaginationInfo(msgList.paging); // save pagination info
      this.setState({ loaded: true });
    } catch (e) {
      if (e.message === '401') {
        if (moment().diff(this.props.loginTime, 'hours') < 12) {
          this.props.addNotification({ message: "Session Timeout", isError: true });
        }
        this.props.signOut();
        this.props.clearMailData();
      } else {
        this.props.addNotification({ messageKey: "L.Error.Retrieve", isError: true });
      }
    }
  }

  public componentDidMount() {
    this.props.clearNotifications();
    if (this.props.wsid !== null && this.props.csrf !== null && this.props.user !== null) {
      this.getMessageList(0, 50);
    }
    // listen to window resize
    window.addEventListener("resize", this.updateWindowSize);
  }

  public componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowSize);
  }

  public updateWindowSize() {
    this.setState({ windowWidth: window.innerWidth });
  }
}

const mapStateToProps = (state: any) => {
  return {
    csrf: state.authentication.csrf,
    isDesc: state.mail.isDesc,
    loginTime: state.authentication.loginTime,
    messageList: state.mail.messageList,
    sortField: state.mail.sortField,
    user: state.authentication.user,
    wsid: state.authentication.wsid,
  };
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    addNotification: bindActionCreators(addNotificationAction, dispatch),
    clearMailData: bindActionCreators(clearMailDataAction, dispatch),
    clearNotifications: bindActionCreators(clearNotificationsAction, dispatch),
    refreshList: bindActionCreators(refreshListAction, dispatch),
    savePaginationInfo: bindActionCreators(savePaginationInfoAction, dispatch),
    selectMessage: bindActionCreators(selectMessageAction, dispatch),
    signOut: bindActionCreators(signOutAction, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(QuarantineManager);



// WEBPACK FOOTER //
// ./src/components/mail/QuarantineManager.tsx